<template>
  <div id="app" class="app">
    <nav v-if="$route.path == '/join-snkrhud-community'">
    </nav>
    <Navigation
      v-else
      v-bind:class="{
        'black-nav': $route.path == '/blog',
      }"
    />
    <router-view />
    <FooterContent
      v-bind:class="{
        'remove-btn': $route.path == '/blog'
      }"
    />
  </div>
</template>
<script>
import Navigation from '@/components/Navigation.vue';
import FooterContent from '@/components/FooterContent.vue';

export default {
  name: 'App',
  components: {
    Navigation,
    FooterContent,
  },
  data() {
    return {

    };
  },
  mounted() {
    document.title = 'SNKRHUD';
    document.getElementById('favicon').href = window.location.origin + '/favicon.png';
  },
};
</script>
<style lang="scss">
body,
html {
  overflow-x: hidden !important;
  scroll-behavior: smooth;
}
.npd {
  padding: 0 !important;
}
button {
  &:hover {
    background-color: transparent !important;
    border: 0 !important;
  }
}
.app {
  width: 100% !important;
}
</style>
